module.exports = __webpack_public_path__ + "8cfdd8738e24ea7e68a9bea27111847e.png";